export default __webpack_public_path__ + "static/media/compute.9ca7cb04.mp4";